/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ExternalOAuthServerForm = {
  /**
   * Exact HTTPS issuer for provider-hosted RFC 8414 discovery. Speakeasy fetches and strictly verifies this issuer before persistence. Supply exactly one of authorization_server_issuer and metadata.
   */
  authorizationServerIssuer?: string | undefined;
  /**
   * JSON object metadata for Speakeasy-hosted compatibility mode. Supply exactly one of metadata and authorization_server_issuer.
   */
  metadata?: any | undefined;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug?: string | undefined;
};

/** @internal */
export type ExternalOAuthServerForm$Outbound = {
  authorization_server_issuer?: string | undefined;
  metadata?: any | undefined;
  slug?: string | undefined;
};

/** @internal */
export const ExternalOAuthServerForm$outboundSchema: z.ZodMiniType<
  ExternalOAuthServerForm$Outbound,
  ExternalOAuthServerForm
> = z.pipe(
  z.object({
    authorizationServerIssuer: z.optional(z.string()),
    metadata: z.optional(z.any()),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      authorizationServerIssuer: "authorization_server_issuer",
    });
  }),
);

export function externalOAuthServerFormToJSON(
  externalOAuthServerForm: ExternalOAuthServerForm,
): string {
  return JSON.stringify(
    ExternalOAuthServerForm$outboundSchema.parse(externalOAuthServerForm),
  );
}
